// All-brands common
import commonView from "../../../../../lib/common/js/components/commonView"
import cookieConsent from "../../../../../lib/common/js/components/cookieConsent"
import pipeHeader from "../../../../../lib/common/js/components/pipeHeader"
import pipeFooter from "../../../../../lib/common/js/components/pipeFooter"
import optionsForm from "../../../../../lib/common/js/components/optionsForm"
import heightForm from "../../../../../lib/common/js/components/heightForm"
import weightForm from "../../../../../lib/common/js/components/weightForm"
import goalPace from "../../../../../lib/common/js/components/goalPace"
import slider from "../../../../../lib/common/js/components/slider"
import walking from "./walking"
import sliderInput from "../../../../../lib/common/js/components/sliderInput"
import exitIntentListener from "../../../../../lib/common/js/components/exitIntentListener"
import timer from "../../../../../lib/common/js/components/timer"
import discountScratchCard from "../../../../../lib/common/js/components/discountScratchCard"
import circularCountdownTimer from "../../../../../lib/common/js/components/circularCountdownTimer"
import animations from "../../../../../lib/common/js/components/animations"
import primer from "../../../../../lib/common/js/components/primer"
import commonBasicPlanCheckout from "../../../../../lib/common/js/components/commonBasicPlanCheckout"
import commonPaymentsBlock from "../../../../../lib/common/js/components/commonPaymentsBlock"
import commonUpsell from "../../../../../lib/common/js/components/commonUpsell"
import commonBasicPlanThankYou from "../../../../../lib/common/js/components/commonBasicPlanThankYou"
import sendOff from "../../../../../lib/common/js/components/sendOff"
import confettiBg from "../../../../../lib/common/js/components/confettiBg"
import signature from "../../../../../lib/common/js/components/signature"
import email from "../../../../../lib/common/js/components/email"
import circularLoading from "../../../../../lib/common/js/components/circularLoading"
import customPlan from "../../../../../lib/common/js/components/customPlan"

// Brand-specific
import targetWeightForm from "../../../../../lib/cf/js/components/targetWeightForm"
import fasterProgress from "../../../../../lib/cf/js/components/fasterProgress"
import viewWithTracking from "../../../../../lib/cf/js/components/viewWithTracking"
import brandBasicPlanCheckout from "../../../../../lib/cf/js/components/brandBasicPlanCheckout"
import discountExpires from "../../../../../lib/cf/js/components/discountExpires"
import results from "../../../../../lib/cf/js/components/results"
import widgetBmi from "../../../../../lib/cf/js/components/widgetBmi"

import upsellChat from "../../../../../lib/cf/js/components/upsellChat"
import upsellPremium from "../../../../../lib/cf/js/components/upsellPremium"
import upsellShoppingList from "../../../../../lib/cf/js/components/upsellShoppingList"
import upsellShoppingListAndPremium from "../../../../../lib/cf/js/components/upsellShoppingListAndPremium"
import upsellWorkouts from "../../../../../lib/cf/js/components/upsellWorkouts"

// Series specific
import getPipeHeaderConfig from "./getPipeHeaderConfig"
import animationsLoaders from "./animationsLoaders"

// Components hierarchy and reusage approach:
// Components are defined on 3 different levels depending on the scope of their usage:
// - All-brands common components are placed in the `lib/common/js/components/`.
// - The brand-specific common for all the given brand's series are placed in `lib/[brand]/js/components`.
// - The exact series specific ones are placed here in `src/[brand]-[series]/src/js/components`.
// This array defines the list of components for this exact series by combining them picked
// from different levels to stay DRY and flexible at the same time.
export default [
  { name: "view", data: commonView },
  { name: "cookieConsent", data: cookieConsent },
  { name: "pipeHeader", data: pipeHeader(getPipeHeaderConfig(pipelineConfig.variant)) },
  { name: "pipeFooter", data: pipeFooter },
  { name: "animations", data: animations(animationsLoaders) },
  { name: "optionsForm", data: optionsForm(commonView) },
  { name: "confettiBg", data: confettiBg },
  { name: "signature", data: signature },
  { name: "results", data: results(commonView) },
  { name: "widgetBmi", data: widgetBmi },
  { name: "slider", data: slider },
  { name: "heightForm", data: heightForm(commonView) },
  { name: "weightForm", data: weightForm(commonView) },
  { name: "targetWeightForm", data: targetWeightForm(commonView) },
  { name: "goalPace", data: goalPace(commonView) },
  { name: "slider", data: slider },
  { name: "walking", data: walking(commonView) },
  { name: "sliderInput", data: sliderInput },
  { name: "circularLoading", data: circularLoading },
  { name: "customPlan", data: customPlan(commonView) },
  { name: "fasterProgress", data: fasterProgress(commonView) },
  { name: "exitIntentListener", data: exitIntentListener },
  { name: "viewWithTracking", data: viewWithTracking(commonView) },
  { name: "timer", data: timer },
  { name: "discountScratchCard", data: discountScratchCard },
  { name: "circularCountdownTimer", data: circularCountdownTimer },
  { name: "paymentsBlock", data: commonPaymentsBlock },
  { name: "primer", data: primer },
  { name: "basicPlanThankYou", data: commonBasicPlanThankYou },
  { name: "email", data: email(commonView) },
  { name: "basicPlanSelection", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "basicPlanPayments", data: brandBasicPlanCheckout(commonBasicPlanCheckout) },
  { name: "upsellPremium", data: upsellPremium(commonUpsell) },
  { name: "upsellShoppingList", data: upsellShoppingList(commonUpsell) },
  { name: "upsellShoppingListAndPremium", data: upsellShoppingListAndPremium(commonUpsell) },
  { name: "upsellWorkouts", data: upsellWorkouts(commonUpsell) },
  { name: "upsellChat", data: upsellChat(commonUpsell) },
  { name: "discountExpires", data: discountExpires },
  { name: "sendOff", data: sendOff },
]
